import PageHeader from '../../components/page-header/page-header.component';
import {
  articleEightText,
  articleElevenText,
  articleFiveText,
  articleFourText,
  articleNineText,
  articleOneText,
  articleSevenTextOne,
  articleSevenTextThree,
  articleSevenTextTwo,
  articleSixText,
  articleTenText,
  articleThreeText,
  articleTwelveText,
  articleTwoText,
  cgvTitles,
  definitionText,
  firstULText,
  secondULText,
  thirdULText
} from './text-CGV';

import '../../styles/legal-page.styles.scss';

const {
  title,
  subtitleOne,
  articleOne,
  articleTwo,
  articleThree,
  articleFour,
  articleFive,
  articleSix,
  articleSeven,
  articleSevenSubititleOne,
  articleSevenSubititleTwo,
  articleEight,
  articleNine,
  articleTen,
  articleEleven,
  articleTwelve
} = cgvTitles;

// `minor` marque les deux sous-sections de l'article 7, qui se lisent sous son
// titre et non à côté ; `italic` le préambule de ce même article.
const BLOCKS = [
  { title: subtitleOne, paragraphs: definitionText, list: firstULText },
  { title: articleOne, paragraphs: articleOneText },
  { title: articleTwo, paragraphs: articleTwoText },
  { title: articleThree, paragraphs: articleThreeText },
  { title: articleFour, paragraphs: articleFourText },
  { title: articleFive, paragraphs: articleFiveText },
  { title: articleSix, paragraphs: articleSixText },
  { title: articleSeven, paragraphs: articleSevenTextOne, italic: true },
  {
    title: articleSevenSubititleOne,
    paragraphs: articleSevenTextTwo,
    minor: true
  },
  {
    title: articleSevenSubititleTwo,
    paragraphs: articleSevenTextThree,
    minor: true
  },
  { title: articleEight, paragraphs: articleEightText },
  { title: articleNine, paragraphs: articleNineText, list: secondULText },
  { title: articleTen, paragraphs: articleTenText },
  { title: articleEleven, paragraphs: articleElevenText },
  { title: articleTwelve, paragraphs: articleTwelveText, list: thirdULText }
];

const CGV = () => {
  return (
    <div className="legal-page">
      <PageHeader overline="Informations" title={title} />

      {BLOCKS.map(({ title, paragraphs, list, italic, minor }) => (
        <section className="legal-block" key={title}>
          <h2 className={minor ? 'legal-block-subtitle' : 'legal-block-title'}>
            {title}
          </h2>

          {paragraphs.map((paragraph) => (
            <p
              className={italic ? 'legal-italic' : undefined}
              key={paragraph.text}
            >
              {paragraph.text}
            </p>
          ))}

          {list && (
            <ul>
              {list.map((item) => (
                <li key={item.text}>{item.text}</li>
              ))}
            </ul>
          )}
        </section>
      ))}

      <p className="legal-date">Tous droits réservés - 4 juillet 2022</p>
    </div>
  );
};

export default CGV;
